/**
 * TabBar — shared sub-page navigation primitive.
 *
 * Pill-button tabs, accent-tinted active state. Source of truth for
 * sub-page navigation across Tank: Statistics, Manage, drawers.
 *
 * Props:
 *   tabs:    [{ id, label, count?, icon? }]
 *   active:  current tab id
 *   onChange: (id) => void
 *   variant: undefined | 'bar'   ('bar' adds the sticky page-top chrome)
 *   className: optional extra class on the root
 */

import clsx from 'clsx';
import styles from './TabBar.module.css';

export default function TabBar({
  tabs,
  active,
  onChange,
  variant,
  className,
}) {
  const rootClass = variant === 'bar' ? styles.tabsBar : styles.tabs;
  return (
    <div className={clsx(rootClass, className)} role="tablist">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={active === t.id}
          className={clsx(styles.tab, active === t.id && styles.active)}
          onClick={() => onChange(t.id)}
        >
          {t.icon && <span className={styles.tabIcon}>{t.icon}</span>}
          <span>{t.label}</span>
          {Number.isFinite(t.count) && (
            <span className={styles.tabCount}>{t.count.toLocaleString()}</span>
          )}
        </button>
      ))}
    </div>
  );
}
